export const fadeStyle = {
	mt: 3,
	backgroundColor: "white",
	position: "absolute",
	zIndex: 1000,
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	">div": {
		flexGrow: 1,
		height: "100%",
	},
};

export function selectButtonStyle(selected, light) {
	return {
		minWidth: 90,
		minHeight: 42,
		py: 0,
		borderRadius: "8px",
		color: selected ? "white" : "black",
		borderColor: selected ? "primary.main" : "grey.300",
		"&:hover,&:active": {
			backgroundColor: light ? "primary.light" : "primary.main",
		},
	};
}

export function inputStyle(error) {
	const borderColor = error ? "error.main" : "grey.300";
	return {
		marginTop: "0px !important",
		marginBottom: "20px",
		maxHeight: 44,
		".MuiInputBase-root": {
			"&:focus-visible": {
				outline: "none",
			},
			"&:hover": {
				borderColor,
			},
			input: {
				fontSize: 14,
				padding: "14px",
				"&[type='number']": {
					"::-webkit-outer-spin-button, ::-webkit-inner-spin-button": {
						WebkitAppearance: "none",
						margin: 0,
					},
				},
			},
			".MuiOutlinedInput-notchedOutline": {
				padding: "14px",
			},

			".MuiOutlinedInput-notchedOutline": {
				fontSize: 14,
				borderColor,
				height: "52px",
			},
			"&.Mui-focused": {
				borderColor,
				".MuiOutlinedInput-notchedOutline": {
					borderColor,
					borderWidth: "1px !important",
				},
			},
		},
	};
}

// 이메일 도메인 셀렉트 선택 인풋
export const EmailInputStyle = {
	minHeight: "unset",
	".MuiSelect-select": {
		fontSize: "32px !important",
		padding: "26px 14px 5px",
	},
	fieldset: {
		border: "none",
		borderRadius: 0,
		borderBottom: "3px solid #BDBDBD !important",
	},
	"& .MuiSelect-icon": {
		width: "1.75rem",
		height: "4rem",
		top: 12,
	},
};

// 이메일 도메인 직접입력 인풋
export const EmailSelectInputStyle = {
	width: "85%",
	position: "absolute",
	top: 0,
	input: {
		fontSize: "32px !important",
	},
	fieldset: {
		border: "none",
		borderRadius: 0,
	},
};

export const keyboardLayout = {
	numeric: ["1 2 3", "4 5 6", "7 8 9", "{hide} 0 {bksp}"],
	default: [
		"` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
		"{tab} q w e r t y u i o p [ ] \\",
		"{lock} a s d f g h j k l ; ' {enter}",
		"{shift} z x c v b n m , . / {shift}",
		".com {space}",
	],
	shift: [
		"~ ! @ # $ % ^ & * ( ) _ + {bksp}",
		"{tab} Q W E R T Y U I O P { } |",
		'{lock} A S D F G H J K L : " {enter}',
		"{shift} Z X C V B N M < > ? {shift}",
		".com {space}",
	],
};

/*
 * ===== 대카테고리 타입 =====
 */

export const BRANCH_LIST = {
	MENU_TYPE_00: "ticket",
	MENU_TYPE_01: "F&B",
	MENU_TYPE_02: "shuttle bus",
	// MENU_TYPE_03: "locker",
	MENU_TYPE_03: "MD",
	MENU_TYPE_04: "park",
	MENU_TYPE_05: "activity",
	MENU_TYPE_06: "etc-service",
	MENU_TYPE_07: "food",
	MENU_TYPE_08: "beverage",
	null: "etc",
};
// 티켓 / Tickets
// F&B / F&B
// 셔틀버스/ Shuttle Bus
// MD / Merch
// 주차장 / Parking
// 체험활동 / Activities
// 기타서비스 / Extras

// 푸드 / Food
// 음료 / Beverage
// ============== //
